<template>
  <div>
    <h2 class="mt-6 mb-6">
      {{ machine.serial_number }}
      <br />
      {{ machine.name }}
    </h2>
    <h3 class="mb-3">
      優惠方案
      <small v-if="!$deal_ids.length" class="red--text ml-3">* 至少擇一</small>
    </h3>

    <v-form>
      <v-card-text>
        <template v-for="deal in tempData">
          <v-checkbox v-model="deal.available" :label="deal.display_name" color="teal"></v-checkbox>
        </template>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!$deal_ids.length" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更優惠方案？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import machineApi from "@/api/machine";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: ["id"],
  data() {
    return {
      machine: {},
      deals: [],
      tempData: [],

      dialog: false
    };
  },

  computed: {
    $deal_ids() {
      const deal_ids = [];
      this.tempData.forEach(deal => {
        if (deal.available) {
          deal_ids.push(deal.deal_id);
        }
      });

      return deal_ids;
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.machine = res.machine;
      this.deals = JSON.parse(JSON.stringify(res.deals));
      this.tempData = JSON.parse(JSON.stringify(res.deals));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.deals));
    },

    submit() {
      machineApi
        .updateDeals(this.id, { deal_ids: this.$deal_ids })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    machineApi
      .getDeals(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
